import React, { useEffect, useState } from 'react';
import api from '../services/api';

const DocumentList = ({ ownerId = null }) => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadDocs = async () => {
    setLoading(true);
    setError('');
    try {
      const endpoint = ownerId ? `/documents/user/${ownerId}` : '/documents/user/me';
      const res = await api.get(endpoint);
      setDocs(res.data || []);
    } catch (err) {
      console.error('Failed to load documents', err);
      // show a friendly message (403/401/400 will be displayed)
      setError(err?.response?.data?.message || 'Failed to load documents');
      setDocs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadDocs(); }, [ownerId]);

  if (loading) return <div>Loading documents...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!docs.length) return <div>No documents found.</div>;

  return (
    <div>
      {docs.map(d => (
        <div key={d.id}>
          <a href={d.file_url} target="_blank" rel="noreferrer">{d.file_name || d.file_url}</a>
          <div style={{ fontSize: 12, color: '#666' }}>{d.doc_type} — {d.doc_year}</div>
        </div>
      ))}
    </div>
  );
};

export default DocumentList;